import { ModelBase } from 'store/model-base';

export class DataPlan extends ModelBase {
    public planType: string;
    public groupCost: string;
    public planSubgroup: string;
    public id: string;
    public numberOfLines: number;
    public monthlyCost: number;
}